const loader = document.querySelector('.page-loader');
const html = document.documentElement;

window.addEventListener('load', e => {
	if (loader) {
		loader.addEventListener('transitionend', (e) => {
			html.classList.add('page--ready');
		}, {once: true});
		html.classList.add('page--loaded');
	}
	else {
		html.classList.add('page--loaded');
		html.classList.add('page--ready');
	}
});